import React from 'react';
import { StyledToastWrapper } from 'src/pages/VerificationPage/components/VerificationPageActions/VerificationReportForm/index.styled';
import { SuccessYellowIcon } from 'src/common/images/SuccessCheckIcon';

export const SuccessToast: React.FC = () => (
  <StyledToastWrapper kind="primary">
    <SuccessYellowIcon />
    <p>
      Raport wysłany! <br /> Sprawdź swoją skrzynkę e-mail.
    </p>
  </StyledToastWrapper>
);
